var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 314 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1751",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "iPhone SE"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13744",
    d: "M0 8c0 6.587 1.412 8 8 8s8-1.412 8-8-1.414-8-8-8-8 1.412-8 8zm1.333 0a17.936 17.936 0 0 0 .292 3.74 3.478 3.478 0 0 0 .847 1.787 3.478 3.478 0 0 0 1.787.847A17.933 17.933 0 0 0 8 14.665a17.934 17.934 0 0 0 3.74-.292 3.478 3.478 0 0 0 1.787-.847 3.478 3.478 0 0 0 .847-1.787A17.934 17.934 0 0 0 14.665 8a17.934 17.934 0 0 0-.292-3.74 3.479 3.479 0 0 0-.847-1.787 3.478 3.478 0 0 0-1.787-.847A17.935 17.935 0 0 0 8 1.333a17.935 17.935 0 0 0-3.74.292 3.479 3.479 0 0 0-1.787.847 3.479 3.479 0 0 0-.848 1.788A17.935 17.935 0 0 0 1.333 8z",
    style: {
      fillRule: "evenodd",
      fill: "#abafd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13745",
    d: "M9.75 5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5z",
    transform: "translate(-3.251 -1.705)",
    style: {
      fill: "#6610f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13746",
    d: "M9 16.25A2.25 2.25 0 1 0 11.25 14 2.25 2.25 0 0 0 9 16.25zm1.5 0a.75.75 0 1 0 .75-.75.75.75 0 0 0-.75.75z",
    transform: "translate(-3.251 -5.056)",
    style: {
      fill: "#6610f2",
      fillRule: "evenodd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.0ef81825561c47b9e379248ea9b94fb5.svg";
export { ForwardRef as ReactComponent };